module.exports = __webpack_public_path__ + "img/jc2.bb9f2459.jpg";